import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const paperlessNgx = defineConnector({
  identifier: "paperlessNgx",
  name: "Paperless-ngx",
  tagLine: "Document management system",
  logo,
  protocol: "http",
  tags: ["documents"],
  defaultUrlPattern: ({ domain }) =>
    domain ? `https://${domain.replace(/\./g, "\\.")}/.*` : "",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.apiKey,
        scheme: "Token",
      },
    ]),
  steps: [
    {
      title: "Enter your Paperless-ngx instance",
      items: [
        {
          kind: "input",
          label: "Instance domain",
          required: true,
          placeholder: "paperless.your-server.com",
          target: { kind: "configuration", field: "domain" },
        },
      ],
    },
    {
      title: "Create an API token",
      items: [
        {
          kind: "markdown",
          content:
            "In Paperless-ngx, go to **Settings › Tokens** or use the API endpoint `/api/token/` to generate a token. See the [API docs](https://docs.paperless-ngx.com/api/) for details.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/api/documents/`,
  },
});
